module.exports = __webpack_public_path__ + "img/tablet-VTA-VALORACION-AGENDADA.2c99a2e8.png";